import React from 'react';
import { useNavigate } from 'react-router-dom';

function Hero() {
  const navigate = useNavigate();
  return (
    <section className="hero-section" style={{ backgroundImage: "url('/final_school_pic.png')", backgroundSize: 'cover', backgroundPosition: 'center right', backgroundRepeat: 'no-repeat' }}>
      <div className="container">
        <div className="hero-grid">
          <div className="hero-content">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '16px' }}>
              <img src="/absloute-logo.jpeg" alt="AbsoluteVision Logo" style={{ width: '80px', height: '80px', objectFit: 'contain', borderRadius: '10px' }} />
              <span style={{ fontSize: '28px', fontWeight: '600', color: '#000' }}>Absolute Vision</span>
            </div>
            <h1 className="hero-headline" style={{ fontSize: '22px' }}>School Management Software</h1>
            <p className="hero-subheadline" style={{ fontSize: '16px', marginBottom: '8px', fontWeight: '500', color: '#1e3a8a', textShadow: '0 1px 2px rgba(255, 255, 255, 0.8)' }}>
              Streamline Your School Operations Efficiently.
            </p>
            <p className="hero-subheadline" style={{ fontSize: '14px', marginBottom: '24px', fontWeight: '400', color: '#333333', lineHeight: '1.6', textShadow: '0 1px 2px rgba(255, 255, 255, 0.6)' }}>
              All-in-one platform to manage students, staff, and academic activities in your school.
            </p>
            
            <div className="hero-cta">
              <button className="btn-hero-primary" onClick={() => navigate('/demo-form')}>Get Started</button>
              <button className="btn-hero-secondary" onClick={() => navigate('/demo-form')} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>▶</span> Watch Demo
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
